var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseBetsApiClient } from "./BaseBetsApiClient";
export var BETS_ENDPOINTS = {
    PLACE_BETS: "/placeBets",
    CALCULATE_BETS: "/calculateBets",
    PRECALCULATE_BETS: "/precalculate"
};
var BetsApiClient = /** @class */ (function (_super) {
    __extends(BetsApiClient, _super);
    function BetsApiClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BetsApiClient.prototype.placeBets = function (request) {
        var fetchOptions = {
            request: request
        };
        return _super.prototype.executeRequest.call(this, BETS_ENDPOINTS.PLACE_BETS, fetchOptions);
    };
    BetsApiClient.prototype.calculateBets = function (request) {
        var fetchOptions = {
            request: request
        };
        return _super.prototype.executeRequest.call(this, BETS_ENDPOINTS.CALCULATE_BETS, fetchOptions);
    };
    BetsApiClient.prototype.precalculateBets = function (request) {
        var fetchOptions = {
            request: request
        };
        return _super.prototype.executeRequest.call(this, BETS_ENDPOINTS.PRECALCULATE_BETS, fetchOptions);
    };
    return BetsApiClient;
}(BaseBetsApiClient));
export { BetsApiClient };
//# sourceMappingURL=BetsApiClient.js.map